package org.hs_soft.runmynesto.domain.model.home.options

import org.hs_soft.runmynesto.domain.model.general.TitleEnum
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager

enum class OptionInfoHeaders : TitleEnum {
    OPERATION,
    SALES_GROUP,
    PRINTER_LOCATIONS,
    CASH_FLOW,
    PRICE_CATEGORY,
    VIRTUAL_CARD,
    CASH_REGISTER_CONFIG,
    EXPORT,
    MENU_CARD_IMPORT,
    RESTAURANT_MANAGER;



    override val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                OPERATION -> strings.operation
                SALES_GROUP -> strings.salesGroups
                PRINTER_LOCATIONS -> strings.printerLocations
                CASH_FLOW -> strings.cashFlow
                VIRTUAL_CARD -> strings.virtualCard
                CASH_REGISTER_CONFIG -> strings.cashRegisterConfig
                EXPORT->strings.export
                PRICE_CATEGORY->strings.priceCategory
                MENU_CARD_IMPORT -> strings.menuCardImport
                RESTAURANT_MANAGER -> strings.restaurantManager
            }
        }
}